import LocationsService from '@/services/codebooks/LocationsService'

export default {
  namespaced: true,
  state: {
    locationsList: []
  },
  getters: {
    locationsList: state => state.locationsList
  },
  actions: {
    refreshLocations ({ commit }) {
      return LocationsService.getAllLocations()
        .then(list => {
          commit('SET_LOCATIONS', list)
        })
    },
    addNewLocation ({ commit }, location) {
      return LocationsService.saveLocation(location).then(result => {
        location.id = result.data
        commit('ADD_LOCATION', location)
        return location
      })
    },
    editLocation ({ commit }, location) {
      return LocationsService.saveLocation(location).then(result => {
        commit('EDIT_LOCATION', location)
        return location
      })
    },
    deleteLocation ({ commit }, location) {
      return LocationsService.removeLocation(location).then(result => {
        commit('DELETE_LOCATION', location)
      })
    }
  },
  mutations: {
    SET_LOCATIONS (state, list) {
      state.locationsList = list
    },
    EDIT_LOCATION (state, location) {
      const current = state.locationsList[location.index]
      current.name = location.name
    },
    ADD_LOCATION (state, location) {
      const newLocation = {
        id: location.id,
        name: location.name
      }
      state.locationsList.push(newLocation)
    },
    DELETE_LOCATION (state, location) {
      state.locationsList.splice(location.index, 1)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/codebook/locations.js